import hea01Header from '../../modules/HEA01-header/HEA01-header';
import foo01Footer from '../../modules/FOO01-footer/FOO01-footer';
import cookieNotification from '../../common/cookie-notification/cookie-notification';
import gdprNotification from '../../common/cookie-notification/gdpr-notification';
import mdl06Concern from '../../modules/MDL06-concern/MDL06-concern.js';
import mdl07Warning from '../../modules/MDL07-warning/MDL07-warning';
import mdl08NewItemInCart from '../../modules/MDL08-new-item-in-cart/MDL08-new-item-in-cart';
import mdl09SameItemInCart from '../../modules/MDL09-same-item-in-cart/MDL09-same-item-in-cart';
import ConfirmationModal from '../../modules/SET01-settlement/confirmation-modal/confirmation-modal.js';
import popup from '../../common/popup/popup.vue';
import oni01OnlineInquiry from '../../modules/ONI01-online-inquiry/ONI01-online-inquiry'

import centralStore from '../../common/central-vuex-store/central.vuex';
import loaderStore from '../../common/component-loader/component-loader-vuex';
import headerStore from '../../modules/HEA01-header/HEA01-header.vuex';
import concernModalStore from '../../modules/MDL06-concern/MDL06-concern-vuex';
import warningModalStore from '../../modules/MDL07-warning/MDL07-warning-vuex';
import newItemInCartModalStore from '../../modules/MDL08-new-item-in-cart/MDL08-new-item-in-cart-vuex';
import {
	store as cartsStore,
	watchActiveAddress,
	activeAddressCallback
} from '../../stores/carts.store.js';
import settlementStore from '../../stores/settlement.store.js';

import {NumberGroupingFormatter} from '../../common/utils/filters/numberGroupingFormatter';
import {TitleMaskedFilter} from '../../common/utils/filters/titleMaskedFilter';

import Vue from 'vue';
import Vuex, {mapActions} from 'vuex';
import {mediaQueries} from '../../common/mediaQuery/mediaQuery';
import {DatePicker} from 'element-ui';

import eventBus from '../../common/event-bus/event-bus';
window.EventBus = eventBus;

import { gtmScript } from '../../common/cookie-notification/gtm';

gtmScript(window.gtmSiteKey);
window.dataLayer = window.dataLayer || [];

export const store = new Vuex.Store(centralStore);
store.registerModule('headerStore', headerStore);
store.registerModule('loaderStore', loaderStore);
store.registerModule('cartsStore', cartsStore);
store.watch(watchActiveAddress, activeAddressCallback);
store.registerModule('newItemInCartModalStore', newItemInCartModalStore);
store.registerModule('warningModalStore', warningModalStore);
store.registerModule('concernModalStore', concernModalStore);
store.registerModule('settlementStore', settlementStore);

Vue.filter('numberGroupingFormatter', NumberGroupingFormatter);
Vue.filter('titleMaskedFilter', TitleMaskedFilter);

Vue.use(DatePicker);

export const base = {
	components: {
		'not01-notification': cookieNotification,
		'not03-notification': gdprNotification,
		'hea01-header': hea01Header,
		'foo01-footer': foo01Footer,
		'mdl06-concern': mdl06Concern,
		'mdl07-warning': mdl07Warning,
		'mdl08-new-item-in-cart': mdl08NewItemInCart,
		'mdl09-same-item-in-cart': mdl09SameItemInCart,
		'confirmation-modal': ConfirmationModal,
		popup
	},
	mediaQueries,
	store,
	methods: {
		...mapActions('cartsStore', ['getCarts'])
	},
	created() {
		this.getCarts();
	}
};



// WEBPACK FOOTER //
// ../source/build-entry/layouts/basicLayout.js